import GetStrLocalized from '../../datas/GetStrLocalized'
import SearchInput from "./SearchInput";
import { HcContext } from "../../types/hccontext";


interface MainSearchInputProps {
	language: string;
	searchValue: string;
    hcContext: HcContext;
}

function MainSearchInput({ language, searchValue, hcContext }: Readonly<MainSearchInputProps>) {
	return <SearchInput placeholder={GetStrLocalized(language, "search")} searchValue={searchValue} searchPath={'/' + language + '/' + GetStrLocalized(language, "searchFolderName") + '/'}
		language={language} hcContext={hcContext} />
}

export default MainSearchInput
